module.exports = __webpack_public_path__ + "img/spain-cancer-female.77417bfe.png";